import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import {
  setOptionsExpanded,
  setProjectTabValue
} from "../../store/actions/common";
import { isEmptyObj, isNotEmptyRoute } from "../../utils/helpers";
import {
  setProjectDetails
} from "../../store/actions/project";
import { Box, makeStyles } from "@material-ui/core";

import ProjectBody from "./ProjectBody";
import { setInfoDialog } from "../../store/actions/common";
import useProductTour from "../../states/tour/tours/product";
import { setExtendableId, setExtendableType } from "../../store/actions/edit";
import UploadStopsDialog from "../UploadStopsDialog/UploadStopsDialog";
import { setUploadStopsOpen } from "../../store/actions/account";

import Header from "./Header";
import RoutingSettings from "./RoutingSettings";
import BottomActions from "./BottomActions";
import clsx from "clsx";

// FIXME: Maybe remove or move to project body
const useStyles = makeStyles(theme => ({
  projectBody: {
    overflow: "hidden"
  }
}));

function Project(props) {
  const {
    solution,
    projectName,
    projectDate,
    currentWindow,
    setOptionsExpanded,
    projectExpired,
    projectPublished,
    publishedOnce,
    stopsCount,
    setExpanded,
    projectId,
    setProjectDetails,
    userData,
    vehiclesCount,
    tabValue,
    setProjectTabValue,
  } = props;

  // General
  const classes = useStyles();

  // Product tour
  const [autoProductTourDone, setAutoProductTourDone] = useState(false);
  const productTour = useProductTour();

  // Variables
  const organisation =
    userData.organisationSite && userData.organisationSite.organisation;
  const expired =
    organisation &&
    ((organisation.subscription_status === "trialing" &&
      new Date() > new Date(organisation.trial_end * 1000)) ||
      organisation.subscription_status === "canceled");
  const incompleteSubscriptionStatus =
    organisation?.subscription_status === "incomplete";

  // Effects
  // Show product tour part two or three if not completed totally
  useEffect(() => {
    if (productTour.hasActiveTourCurrently()) {
      setAutoProductTourDone(true);
      return;
    }
    if (!autoProductTourDone && projectDate) {
      if (
        organisation &&
        !expired &&
        !incompleteSubscriptionStatus &&
        organisation.onboarding &&
        !organisation.onboarding.product_tour_completed
      ) {
        if (
          !organisation.onboarding.product_tour_part_2_completed &&
          !projectExpired &&
          !solution &&
          !projectPublished &&
          stopsCount === 0
        ) {
          productTour.startTour({ fromPart: "two" });
          setAutoProductTourDone(true);
        } else if (
          !organisation.onboarding.product_tour_part_3_completed &&
          !projectExpired &&
          solution &&
          !publishedOnce
        ) {
          setProjectTabValue(1);
          productTour.startTour({ fromPart: "three" });
          setAutoProductTourDone(true);
        }
      }
    }
  }, [
    autoProductTourDone,
    expired,
    incompleteSubscriptionStatus,
    organisation,
    productTour,
    projectDate,
    projectExpired,
    projectPublished,
    publishedOnce,
    setProjectTabValue,
    solution,
    stopsCount,
    vehiclesCount
  ]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      id="project_wrapper"
      className={clsx(projectDate && "project-loaded")}
    >
      <Header
        projectDate={projectDate}
        projectName={projectName}
        projectExpired={projectExpired}
        setOptionsExpanded={setOptionsExpanded}
        projectId={projectId}
        setProjectDetails={setProjectDetails}
        stopsCount={stopsCount}
        routesCount={
          solution && Object.keys(solution?.routeGroups).length
            ? solution?.routeGroups[
                Object.keys(solution?.routeGroups)[0]
              ].filter(backhaulGroup =>
                backhaulGroup.some(route => isNotEmptyRoute(route))
              ).length
            : 0
        }
        publishedOnce={publishedOnce}
        projectPublished={projectPublished}
      />
      <UploadStopsDialog />
      <Box className={classes.projectBody}>
        <ProjectBody
          stopsCount={stopsCount}
          setExpanded={setExpanded}
          currentWindow={currentWindow}
          tabValue={tabValue}
        />
      </Box>
      {tabValue !== 2 && <BottomActions />}
      <RoutingSettings />
    </Box>
  );
}

function mapStateToProps(state) {
  return {
    projectId: state.project.id,
    userData: state.auth.userData,
    projectName: state.project.name,
    projectDate: state.project.project_date,
    solution: state.project.solution,
    currentWindow: state.common.currentWindow,
    stopsCount: state.project.vrp.stops.filter(
      task =>
        task.type !== "start" &&
        task.type !== "end" &&
        !isEmptyObj(task) &&
        task.type !== "break"
    ).length,
    projectPublished: state.project.status.toLowerCase() === "published",
    projectExpired: ["expired", "finished"].includes(
      state.project.status.toLowerCase()
    ),
    tour: state.tour,
    publishedOnce: state.project.published_once,
    saveDisabled:
      state.extendable.saveDisabled && state.common.settingsSaveDisabled,
    vehiclesCount: state.project.selectedVehicles.length,
    plan:
      (state.auth.userData.organisationSite &&
        state.auth.userData.organisationSite.organisation.plan) ||
      {},
    tabValue: state.common.projectTabValue
  };
}

export default connect(mapStateToProps, {
  setOptionsExpanded,
  setProjectDetails,
  setInfoDialog,
  setExtendableType,
  setExtendableId,
  setUploadStopsOpen,
  setProjectTabValue
})(Project);
